import { registerPlugin } from "@capacitor/core";
const HomeIndicator = registerPlugin("HomeIndicator", {
    web: () => import("./web").then((m) => new m.HomeIndicatorWeb()),
});
export * from "./definitions";
export { HomeIndicator };
//# sourceMappingURL=index.js.map